export enum TraversalPurpose {
    SIDE_MENU,
    COMPARE_SIDE_MENU_1,
    WIDGET_SELECTOR
}
